import JsonApi from "@/custolink-logic/api/JsonApi";


export enum AdmSettingsLookAndFeelApi$UploadLogoContext { "MainLogo" = "MainLogo" , "QrLogo" = "QrLogo"};

export enum AdmUserApi$AuthInfoPermission { "CONTROLPANEL" = "CONTROLPANEL" , "USER_MANAGEMENT" = "USER_MANAGEMENT"};

export enum AdmUserNotificationsApi$LatestNotificationType { "AssetAiConversation" = "AssetAiConversation" , "AssetVideoCall" = "AssetVideoCall" , "Inquiry" = "Inquiry" , "ProductRegistered" = "ProductRegistered"};

export interface AdmHomeApi$DashboardStats {
    assetCount: number;
    enduserCount: number;
    fileCount: number;
    userCount: number;
}

export interface AdmSettingsLookAndFeelApi$GetInfo {
    smsSenderId: string;
    title: string;
}

export interface AdmSettingsLookAndFeelApi$GetValues {
    assetFrontendBgcolorHex: string;
    assetFrontendSnoSearchbarPlaceholder: string;
}

export interface AdmSettingsLookAndFeelApi$SaveInfo {
    smsSenderId: string;
    title: string;
}

export interface AdmSettingsLookAndFeelApi$SaveStyle {
    assetFrontendBgcolorHex: string;
    assetFrontendSnoSearchbarPlaceholder: string;
}

export interface AdmSettingsUsersApi$CreateEndUserInput {
    email: string;
    name: string;
    phone: string;
    sendWelcomeEmail: boolean;
}

export interface AdmSettingsUsersApi$CreateEndUserResult {
    id: number;
}

export interface AdmSettingsUsersApi$CreateUserInput {
    email: string;
    name: string;
}

export interface AdmSettingsUsersApi$CreateUserResult {
    id: number;
}

export interface AdmSettingsUsersApi$EditEndUserInput {
    email: string;
    name: string;
    phone: string;
}

export interface AdmSettingsUsersApi$EndUser {
    email: string | null;
    emailUnverified: string | null;
    id: number;
    name: string;
    phone: string;
    userDeletable: boolean;
}

export interface AdmSettingsUsersApi$EndUsers {
    items: AdmSettingsUsersApi$EndUser[];
    pageSize: number;
    totalElements: number;
}

export interface AdmSettingsUsersApi$PendingInvite {
    email: string;
    expired: boolean;
    expiresAt: string;
    url: string;
}

export interface AdmSettingsUsersApi$User {
    authorities: string[];
    email: string;
    emailUnverified: string;
    id: number;
    isAdmin: boolean;
    name: string;
    pendingConfirmInvite: boolean;
    pendingInviteExpired: boolean;
    userDeletable: boolean;
}

export interface AdmSettingsUsersApi$Users {
    items: AdmSettingsUsersApi$User[];
    pageSize: number;
    totalElements: number;
}

export interface AdmUserApi$CurrentAuthedUser {
    auth: boolean;
    email: string;
    emailUnverified: string | null;
    globalPermissions: AdmUserApi$AuthInfoPermission[];
    name: string;
    orgPermissions: AdmUserApi$AuthInfoPermission[];
    orgRoles: string[];
    username: string;
}

export interface AdmUserNotificationsApi$LatestNotification {
    createdPrettyDate: string;
    id: number;
    isRead: boolean;
    type: AdmUserNotificationsApi$LatestNotificationType;
}

export interface AdmUserNotificationsApi$LatestNotifications {
    list: AdmUserNotificationsApi$LatestNotification[];
}

export interface AdmUserNotificationsApi$MultipleIds {
    ids: number[];
}

export interface AdmUserProfileApi$GetInfo {
    email: string | null;
    emailUnverified: string | null;
    enableEmailNotifications: boolean;
    phone: string | null;
    phoneUnverified: string | null;
    timezone: string;
    userDisplayName: string;
}

export interface AdmUserProfileApi$UpdateInput {
    currentPassword: string;
    email: string;
    enableEmailNotifications: boolean;
    name: string;
    timezone: string;
}

export interface AdmUserProfileApi$UpdatePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export interface AdmUserProfileApi$UpdatePhoneInput {
    currentPassword: string;
    phone: string;
    phoneVerificationCode: string;
}

export interface AdmUserProfileApi$UpdateResult {
    emailChanged: boolean;
    nameChanged: boolean;
}

export interface AssetFrontendUserApi$CurrentAuthedUser {
    auth: boolean;
    email: string;
    emailUnverified: string | null;
    name: string;
    username: string;
}

export interface CpI18nApi$GetInfo {
    languages: CpI18nApi$GetInfoLanguage[];
    namespaces: CpI18nApi$Namespace[];
}

export interface CpI18nApi$GetInfoLanguage {
    code: string;
    name: string;
}

export interface CpI18nApi$Namespace {
    name: string;
    properties: CpI18nApi$Property[];
    rows: CpI18nApi$NamespaceRow[];
}

export interface CpI18nApi$NamespaceRow {
    langValues: string[];
    propertyKey: string;
}

export interface CpI18nApi$Property {
    key: string;
}

export interface CpI18nApi$SaveEntry {
    langCode: string;
    propertyKey: string;
    value: string;
}

export interface CpI18nApi$SaveInfo {
    entries: CpI18nApi$SaveEntry[];
}
export interface PublicAdmUserSignInApi$SigninInput {
    email: string;
    organisationId: number;
    password: string;
}

export interface PublicSharedUserApi$ForgotPasswordInput {
    email: string;
    organisationId: number;
    originAdminArea: boolean;
}

export interface PublicSharedUserApi$GetVerifyEmailTokenInfo {
    errorMessageIfNotOk: string;
    mustSetPassword: boolean;
    ok: boolean;
}

export interface PublicSharedUserApi$ResetPasswordInput {
    newPassword: string;
    organisationId: number;
    token: string;
}

export interface PublicSharedUserApi$VerifyEmailAndSetPasswordInput {
    newPassword: string | null;
    token: string;
}

export interface WebAppMainApi$Configuration {
    paths: WebAppMainApi$Paths;
    serverUrlParamsForAccountPages: WebAppMainApi$ServerUrlParamsForAccountPages;
}

export interface WebAppMainApi$ControlpanelContext {
    field: string;
}

export interface WebAppMainApi$LookAndFeel {
    assetFrontendBgcolorHex: string | null;
    assetFrontendNewDesign: boolean;
    assetFrontendSnoSearchbarPlaceholder: string;
    i18nAssetFrontendSnoSearchbarPlaceholder: string | null;
    logoUrl: string;
    qrLogoUrl: string;
}

export interface WebAppMainApi$OrganisationContext {
    assetFrontendi18nEnabled: boolean;
    assetFrontendi18nLanguageCodes: string[];
    cstlnDataIntegrationEnabled: boolean;
    lookAndFeel: WebAppMainApi$LookAndFeel;
    organisationId: number;
    organisationSlug: string;
}

export interface WebAppMainApi$Paths {
    accountRootPath: string;
    accountSignInSubPath: string;
    accountSignUpSubPath: string;
}

export interface WebAppMainApi$ServerUrlParamsForAccountPages {
    errorParamName: string;
    errorParamValueErrorCodePrefix: string;
    errorParamValueNotRegistered: string;
    optionalMobileAppToken: string;
    successBooleanParamName: string;
}

export interface WebAppMainApi$UiContext {
    controlpanelContext: WebAppMainApi$ControlpanelContext | null;
    environmentBanner: string | null;
    organisationContext: WebAppMainApi$OrganisationContext | null;
}
export const AdmHomeApi = {
  getDashboardStats: (orgId:number) : Promise<AdmHomeApi$DashboardStats> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/home/dashboard_stats")
  },
}
export const AdmSettingsLookAndFeelApi = {
  getGeneral: (orgId:number) : Promise<AdmSettingsLookAndFeelApi$GetInfo> => {
    return JsonApi.get("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/look_and_feel/general")
  },
  getValues: (orgId:number) : Promise<AdmSettingsLookAndFeelApi$GetValues> => {
    return JsonApi.get("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/look_and_feel/values")
  },
  saveGeneral: (orgId:number,input:AdmSettingsLookAndFeelApi$SaveInfo) : Promise<void> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/look_and_feel/general",input)
  },
  saveStyle: (orgId:number,input:AdmSettingsLookAndFeelApi$SaveStyle) : Promise<void> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/look_and_feel/style",input)
  },
  uploadLogoImage: (orgId:number,file:File,context:AdmSettingsLookAndFeelApi$UploadLogoContext) : Promise<void> => {
    return JsonApi.post_form("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/look_and_feel/upload_logo_image",{"file": file,"context": context})
  },
}
export const AdmSettingsUsersApi = {
  createEndUser: (orgId:number,user:AdmSettingsUsersApi$CreateEndUserInput) : Promise<AdmSettingsUsersApi$CreateEndUserResult> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/create_end_user",user)
  },
  createUser: (orgId:number,user:AdmSettingsUsersApi$CreateUserInput) : Promise<AdmSettingsUsersApi$CreateUserResult> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/create_user",user)
  },
  deleteUser: (orgId:number,userId:number) : Promise<void> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/delete_user/" + userId + "")
  },
  editEndUser: (orgId:number,userId:number,user:AdmSettingsUsersApi$EditEndUserInput) : Promise<void> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/edit_end_user?userId="+ ( userId == null ? "" : userId ) +"",user)
  },
  getEndUsers: (orgId:number,searchfilter:string,page:number,pageSize:number) : Promise<AdmSettingsUsersApi$EndUsers> => {
    return JsonApi.get("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/end_users_list?searchfilter="+ ( searchfilter == null ? "" : searchfilter ) +"&page="+ ( page == null ? "" : page ) +"&pageSize="+ ( pageSize == null ? "" : pageSize ) +"")
  },
  getPendingInvite: (orgId:number,userId:number) : Promise<AdmSettingsUsersApi$PendingInvite> => {
    return JsonApi.get("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/pending_invite?userId="+ ( userId == null ? "" : userId ) +"")
  },
  getUsers: (orgId:number,page:number,pageSize:number) : Promise<AdmSettingsUsersApi$Users> => {
    return JsonApi.get("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/users_list?page="+ ( page == null ? "" : page ) +"&pageSize="+ ( pageSize == null ? "" : pageSize ) +"")
  },
  resendInvite: (orgId:number,userId:number) : Promise<void> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/resend_invite?userId="+ ( userId == null ? "" : userId ) +"")
  },
  sendEditUserWelcomeEmail: (orgId:number,userId:number) : Promise<void> => {
    return JsonApi.post("api/admin/bc/identity_and_access/organisation/" + orgId + "/settings/users/send_end_user_welcome_email?userId="+ ( userId == null ? "" : userId ) +"")
  },
}
export const AdmUserApi = {
  getCurrentAuthedUser: () : Promise<AdmUserApi$CurrentAuthedUser> => {
    return JsonApi.get("api/admin/bc/identity_and_access/user")
  },
  signout: () : Promise<void> => {
    return JsonApi.get("api/admin/bc/identity_and_access/user/signout")
  },
}
export const AdmUserNotificationsApi = {
  getLatest10NotificationsForOrganisationAdminArea: () : Promise<AdmUserNotificationsApi$LatestNotifications> => {
    return JsonApi.get("api/admin/bc/identity_and_access/user/notifications/latest_10")
  },
  markAsRead: (notificationId:number) : Promise<void> => {
    return JsonApi.put("api/admin/bc/identity_and_access/user/notifications/mark_as_read/" + notificationId + "")
  },
  markMultipleAsRead: (input:AdmUserNotificationsApi$MultipleIds) : Promise<void> => {
    return JsonApi.put("api/admin/bc/identity_and_access/user/notifications/mark_multiple_as_read",input)
  },
}
export const AdmUserProfileApi = {
  getInfo: () : Promise<AdmUserProfileApi$GetInfo> => {
    return JsonApi.get("api/admin/bc/identity_and_access/user/profile/info")
  },
  update: (input:AdmUserProfileApi$UpdateInput) : Promise<AdmUserProfileApi$UpdateResult> => {
    return JsonApi.put("api/admin/bc/identity_and_access/user/profile/update",input)
  },
  updatePassword: (input:AdmUserProfileApi$UpdatePasswordInput) : Promise<void> => {
    return JsonApi.put("api/admin/bc/identity_and_access/user/profile/update_password",input)
  },
  updatePhone: (input:AdmUserProfileApi$UpdatePhoneInput) : Promise<void> => {
    return JsonApi.put("api/admin/bc/identity_and_access/user/profile/update_phone",input)
  },
}
export const AssetFrontendUserApi = {
  getCurrentAuthedUser: () : Promise<AssetFrontendUserApi$CurrentAuthedUser> => {
    return JsonApi.get("api/asset_frontend/bc/identity_and_access/user")
  },
  signout: () : Promise<void> => {
    return JsonApi.get("api/asset_frontend/bc/identity_and_access/user/signout")
  },
}
export const CpI18nApi = {
  get: (orgId:number) : Promise<CpI18nApi$GetInfo> => {
    return JsonApi.get("api/admin/bc/identity_and_access/controlpanel/organisation/" + orgId + "/i18n")
  },
  save: (orgId:number,input:CpI18nApi$SaveInfo) : Promise<void> => {
    return JsonApi.put("api/admin/bc/identity_and_access/controlpanel/organisation/" + orgId + "/i18n",input)
  },
}

export const PublicAdmUserSignInApi = {
  signin: (dto:PublicAdmUserSignInApi$SigninInput) : Promise<void> => {
    return JsonApi.post("public-api/admin/bc/identity_and_access/user/signin",dto)
  },
}
export const PublicAssetFrontendI18nApi = {
  loadNamespace: (uiAppScope:string,language:string,namespace:string) : Promise<{ [key: string]: string; }> => {
    return JsonApi.get("public-api/asset_frontend/bc/identity_and_access/i18n/" + uiAppScope + "?language="+ ( language == null ? "" : language ) +"&namespace="+ ( namespace == null ? "" : namespace ) +"")
  },
}
export const PublicSharedUserApi = {
  forgotPassword: (input:PublicSharedUserApi$ForgotPasswordInput) : Promise<void> => {
    return JsonApi.post("public-api/shared/bc/identity_and_access/user/forgot_password",input)
  },
  getVerifyEmailTokenInfo: (token:string) : Promise<PublicSharedUserApi$GetVerifyEmailTokenInfo> => {
    return JsonApi.get("public-api/shared/bc/identity_and_access/user/verify_email_token_info?token="+ ( token == null ? "" : token ) +"")
  },
  resetPassword: (input:PublicSharedUserApi$ResetPasswordInput) : Promise<void> => {
    return JsonApi.put("public-api/shared/bc/identity_and_access/user/reset_password",input)
  },
  verifyEmailAndSetPassword: (input:PublicSharedUserApi$VerifyEmailAndSetPasswordInput) : Promise<void> => {
    return JsonApi.put("public-api/shared/bc/identity_and_access/user/verify_email_and_set_password",input)
  },
}
export const PublicTimezoneApi = {
  getTimezones: () : Promise<Array<string>> => {
    return JsonApi.get("public-api/admin/bc/identity_and_access/timezone")
  },
}
export const WebAppMainApi = {
  getConfiguration: () : Promise<WebAppMainApi$Configuration> => {
    return JsonApi.get("public-api/main/configuration")
  },
  getUiContext: (hostname:string) : Promise<WebAppMainApi$UiContext> => {
    return JsonApi.get("public-api/main/ui-context?hostname="+ ( hostname == null ? "" : hostname ) +"")
  },
}
